
import { defineComponent } from 'vue'
import CancelPlanModal from './Modals/CancelPlanModal.vue'

export default defineComponent({
  name: 'CancelPlan',
  components: {
    CancelPlanModal
  },
  data() {
    return {
      showCancelPlanModal: false
    }
  }
})
